<template>
  <section style="width: 100%">
    <div class="">
      <!-- ${vmode==0?(ids.length>0 && vmode==0?'80%':'inherit'):'100%'} -->
      <Cascader
        :class="lkey"
        :popper-class="lkey"
        v-if="!hidedroptree"
        :props="cscdrProps"
        :options="locTypesCascader"
        @change="cascaderOnChange"
        v-model="selectedTypes"
        :collapse-tags="true"
        filterable
        clearable
        :style="`width: 100%`"
      ></Cascader>
      <div v-if="ids.length > 0 && vmode == 0" class="mg-l-20">
        <a role="button" @click="openMdl()" class="btn btn-light"
          >Харах ({{ ids.length }})</a
        >
      </div>
      <div v-else-if="ids.length > 0 && vmode == 1">
        <Tree
          node-key="id"
          :data="selectedCascader"
          :props="selcdProps"
          :default-expand-all="true"
          highlight-current
          @node-click="treeItemClick"
        >
          <div class="custom-tree-node mg-y-5" slot-scope="{ node, data }">
            <div
              class="text-truncate tx-12"
              :title="node.label"
              :class="{
                'font-weight-bolder': data.ch == null || data.ch.length == 0,
              }"
            >
              {{ data.t }}
            </div>
            <div
              v-if="data.ch == null || data.ch.length == 0"
              class="btn-group btn-xs"
            >
              <button class="btn btn-xs btn-uppsercase">
                <feather type="arrow-right" class="wd-15-f ht-15-f"></feather>
                мэдээлэл харах
              </button>
            </div>
          </div>
        </Tree>
      </div>
    </div>
    <b-modal
      v-model="modalObj.show"
      :title="'Сонгосон ' + titl"
      size="xl"
      scrollable
      centered
      hide-footer
    >
      <Tree
        ref="folterTree"
        node-key="id"
        node-key1="label"
        :data="selectedCascader"
        :props="selcdProps"
        :default-expand-all="true"
        highlight-current
        @node-click="treeItemClick"
      >
        <div class="custom-tree-node mg-y-5" slot-scope="{ node, data }">
          <div
            class="text-truncate tx-12"
            :title="node.label"
            :class="{
              'font-weight-bolder': data.ch == null || data.ch.length == 0,
            }"
          >
            {{ node.label }}
          </div>
          <div
            v-if="data.ch == null || data.ch.length == 0"
            class="btn-group btn-xs"
          >
            <button class="btn btn-xs btn-uppsercase">
              <feather type="arrow-right" class="wd-15-f ht-15-f"></feather>
              мэдээлэл харах
            </button>
          </div>
        </div>
      </Tree>
    </b-modal>

    <b-modal
      v-model="detailObj.show"
      hide-footer
      scrollable
      :title="`${detailObj.data.name}-н тодорхойлолт`"
      size="lg"
    >
      <div v-if="detailObj.render">
        <div class="mail-group-body" style="position: relative">
          <label class="mail-group-label">Монгол нэр</label>
          <div class="pd-10" v-html="detailObj.data.name"></div>
        </div>

        <div class="mail-group-body" style="position: relative">
          <label class="mail-group-label">Тодорхойлолт монгол</label>
          <div class="pd-10" v-html="detailObj.data.value"></div>
        </div>

        <div class="mail-group-body" style="position: relative">
          <label class="mail-group-label">Англи нэр</label>
          <div class="pd-10" v-html="detailObj.data.field1"></div>
        </div>

        <div class="mail-group-body" style="position: relative">
          <label class="mail-group-label">Эх сурвалж</label>
          <div class="pd-10" v-html="detailObj.data.field2"></div>
        </div>

        <div class="mail-group-body" style="position: relative">
          <label class="mail-group-label">Хам сэдэв</label>
          <div class="pd-10" v-html="detailObj.data.field3"></div>
        </div>

        <div class="mail-group-body" style="position: relative">
          <label class="mail-group-label">Тодорхойлолт англи</label>
          <div class="pd-10" v-html="detailObj.data.field4"></div>
        </div>

        <div class="mail-group-body" style="position: relative">
          <label class="mail-group-label">Нэр /Монгол бичиг/</label>
          <div class="pd-10" v-html="detailObj.data.field5"></div>
        </div>
      </div>
    </b-modal>
  </section>
</template>

<script>
import { request } from "@/api/all";
import "element-ui/lib/theme-chalk/index.css";
import { Cascader, Tree } from "element-ui";

export default {
  components: { Cascader, Tree },
  name: "locTypeCascaderPanel",
  props: {
    titl: {
      type: String,
      default: () => "",
    },
    ids: {
      type: Array,
      default: () => [],
    },
    lkey: {
      type: String,
      default: () => "",
    },
    vmode: {
      type: Number,
      default: () => 0,
    },
    hidedroptree: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      modalObj: {
        show: false,
      },
      cscdrProps: {
        // value: 'i',
        // label: 't',
        // children: "ch",

        value: "value",
        label: "label",
        children: "children",
        multiple: true,
        // checkStrictly: true
      },

      selcdProps: {
        value: "i",
        label: "t",
        children: "ch",
      },
      locTypesCascader: [],
      selectedCascader: [],
      selectedTypes: [],

      detailObj: {
        data: {
          name: "",
        },
        render: true,
        show: false,
      },
    };
  },
  mounted() {
    // console.log('this.lkey', this.lkey, this.ids);
    //if(this.vmode==0){
    this.init();
    //}

    // if(this.vmode==1){
    //   this.cascaderOnChange(this.ids);
    // }
  },
  methods: {
    cascaderOnChange(value) {
      //console.log("cascaderOnChange", value);
      let _lasts = [];
      value.forEach((x) => {
        // if (Array.isArray(e[x])) {
        //   e[x].forEach((a) => {
        //     params += "&" + x + "=" + a;
        //   });
        // } else {
        //   params += "&" + x + "=" + e[x];
        // }
        let _id = x[x.length - 1] != undefined ? x[x.length - 1] : null;
        _lasts.push(_id);
      });
      //console.log('_lasts', _lasts);
      this.$emit("input", _lasts);
      this.$emit("on-selected", _lasts);
    },
    toggleBodyClass(addRemoveClass, className) {
      //console.log('toggleBodyClass fired');
      const el = document.body;

      if (addRemoveClass === "addClass") {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },
    init() {
      let self = this;

      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        params: { key: this.lkey },
        api: { url: "Type/GetAsyncTreeDataFullname", method: "get" },
        store: this.$store,
      }).then((res) => {
        this.toggleBodyClass("removeClass", "dynamic-locker");

        if (res != false) {
          //console.log('res.data s', res.data, this.lkey);
          this.locTypesCascader = res.data.types;
          //this.selectedTypes = this.ids

          if (this.ids.length) {
            let _selecteds = [];
            this.ids.forEach((x) => {
              self.selectedTypes = [];
              self.cascaderModelRecursive(res.data.flat, x);
              //console.log('x', x, );
              _selecteds.push(self.selectedTypes.reverse());
            });
            this.selectedTypes = _selecteds;

            if (this.vmode == 1) {
              this.openMdl();
            }
          }
        }
      });
    },
    cascaderModelRecursive(data, cid) {
      //console.log('data', data);
      this.selectedTypes.push(cid);
      let pid = data.filter((d) => d.i == cid)[0].p;
      if (pid > 0) {
        //console.log('pid olsnu', pid);
        this.cascaderModelRecursive(data, pid);
      }
    },

    openMdl() {
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        data: { ids: this.selectedTypes },
        api: { url: "Type/getAsyncTreeDataBySelectedIdS", method: "POST" },
        store: this.$store,
      }).then((res) => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          this.selectedCascader = res.data.types;

          if (this.vmode == 0) {
            this.modalObj.show = true;
          }
        }
      });
    },
    treeItemClick(e) {
      //console.log(e);
      if (e.ch != null) return false;

      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        params: { id: e.id },
        api: { method: "GET", url: "Type/GetInheritedDetail" },
        store: this.$store,
      }).then((res) => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          //console.log(res, e.id);
          //this.selectedCascader= res.data.types;
          this.detailObj.data = res.data;
          this.detailObj.render = true;

          this.$nextTick(() => {
            this.detailObj.show = true;
          });
        }
      });
      //e.id
    },
  },
};
</script>
<style>
.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
}
</style>
